import React, { useState } from 'react';
import { Stack, Chip, Tooltip, Collapse, Box } from '@mui/material';
import { grey } from '@mui/material/colors';

export default function PermisosCell ({ permisosArray }) {
  const [expanded, setExpanded] = useState(false);
  
  const permisos = Array.isArray(permisosArray) ? permisosArray : [];
  const limite = 4;
  const tieneMas = permisos.length > limite;

  // Dividimos el array en dos partes
  const iniciales = permisos.slice(0, limite);
  const extra = permisos.slice(limite);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {/* Contenedor principal para los primeros 5 y el botón */}
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ alignItems: 'center' }}>
        {iniciales.map((p, i) => (
          <Chip key={i} label={p} size="small" variant="filled" />
        ))}

        {tieneMas && (
          <Tooltip title={expanded ? "Ver menos" : "Ver todos"}>
            <Chip 
              label={expanded ? "Ver menos" : `+ ${extra.length}`} 
              onClick={() => setExpanded(!expanded)} 
              size="small" 
              variant="filled" 
              clickable 
              sx={{ 
                px:1, 
                minWidth: expanded ? '100px' : '45px',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)', // Curva de velocidad más natural
                "&:hover": { 
                  bgcolor: grey[900],
                  transform: 'scale(1.05)' // Pequeño feedback visual
                },
                "&:active": {
                  transform: 'scale(0.95)' // Efecto de click
                },
                color:'white',
                bgcolor:'black',
              }} 
            />
          </Tooltip>
        )}
      </Stack>

      {/* Contenedor animado para los permisos extra */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Stack 
          direction="row" 
          spacing={0.5} 
          flexWrap="wrap" 
          useFlexGap 
          sx={{ mt: 0.5, pt: 0.5 }}
        >
          {extra.map((p, i) => (
            <Chip key={`extra-${i}`} label={p} size="small" variant="filled" />
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};